const Preview = () => {
    return (
        <div className="preview-container">
            <PreviewHeader />
        </div>
    )
}

export default Preview;

const PreviewHeader = () => {
    return (
        <div className="preview-header">

        </div>
    )
}
